import './JobReportGuestLandingPage.scss';

import React from 'react';
import { IonCol, IonContent, IonGrid, IonPage, IonRow } from '@ionic/react';
import { useGA4 } from '../../utils/ga4';
import stoneAgeLogo from '../../assets/images/logo-dm-stoneage.png';
import { GenericMessages } from '../../intl/GenericMessages';
import { useIntl } from 'react-intl';
import SupportCard from '../../components/experience-card/SupportCard';
import { contactLink } from '../../constants';
import { openBrowser } from '../../utils/browser';
import { ShareValidationMessageCard } from './ShareValidationMessageCard';
import { FailureType } from '../../redux/logInfo/types';

export interface ShareValidationFailedPageProps {
  failureType: FailureType;
  messageParams: Record<string, string>;
}

export const ShareValidationFailedPage: React.FC<ShareValidationFailedPageProps> = ({ failureType, messageParams }) => {
  document.title = 'Share Validation Failed Page'; // Purposely English only for Google Analytics
  useGA4();

  const { formatMessage } = useIntl();

  return (
    <IonPage>
      <IonContent className="security-code-page">
        <img className="landing-page-logo" src={stoneAgeLogo} alt={formatMessage(GenericMessages.stoneAgeLogo)} />
        <IonGrid className={'security-code-page-grid'}>
          <IonRow>
            <IonCol size="12" sizeMd="7">
              <ShareValidationMessageCard failureType={failureType} messageParams={messageParams} />
            </IonCol>
            <IonCol size="12" sizeMd="5">
              <SupportCard
                buttonText={formatMessage(contactLink.buttonText)}
                title={formatMessage(contactLink.title)}
                subtitle={formatMessage(contactLink.subtitle)}
                onClick={() => openBrowser(contactLink.actionUrl)}
              />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
